export const LANG_KEY = "lng";

export const DEFAULT_NAMESPACE = "language";
